import { CheckableFieldComponent } from "./chunk-UIONNZDK.js";
import { Radio_default } from "./chunk-6Y4MXSCS.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCard/RadioCard.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var RADIO_CARD_CLASSNAME_MAP = {
  validation: {
    error: "pd:radio-card--error",
    success: "pd:radio-card--success",
    warning: "pd:radio-card--warning",
    info: "pd:radio-card--info",
    dim: "pd:radio-card--dim"
  }
};
var RadioCard = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      image,
      secondaryAction,
      badge,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "image", "secondaryAction", "badge", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    validation,
    validationMessage,
    className: clsx("pd:radio-card pd:radio-card--primary", validation && RADIO_CARD_CLASSNAME_MAP.validation[validation], className),
    children: [/* @__PURE__ */jsx(CheckableFieldComponent.Input, __spreadValues({
      ref,
      as: Radio_default,
      className: "pd:radio-card__input"
    }, rest)), /* @__PURE__ */jsxs(CheckableFieldComponent.Wrap, {
      className: "pd:radio-card__wrap",
      children: [/* @__PURE__ */jsx(CheckableFieldComponent.Image, {
        className: "pd:radio-card__img",
        children: image
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Label, {
        className: "pd:radio-card__label"
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
        className: "pd:radio-card__description"
      }), (secondaryAction || badge || validation) && /* @__PURE__ */jsxs("footer", {
        className: "pd:mt-auto pd:flex pd:max-w-full pd:flex-col pd:gap-2",
        children: [/* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
          className: "pd:radio-card__secondary-action"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
          className: "pd:radio-card__badge"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
          className: "pd:items-start"
        })]
      })]
    })]
  });
});
var RadioCard_default = RadioCard;
export { RadioCard_default };